import React from 'react';
import style from '../cssmodules/form.module.scss';
import Container from './Container';

function ContactForm() {
  return (
    <div className={style.wrapper}>
      <Container>
        <>
          <h2 className="heading2">Send us a message</h2>
          <form
            className={style.form}
            name="contact"
            method="post"
            action="/success"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
          >
            <input type="hidden" name="bot-field" />
            <input type="hidden" name="form-name" value="contact" required />
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Name"
              required
            />
            <input
              type="text"
              name="company"
              id="company"
              placeholder="Company"
              required
            />
            <input
              type="text"
              name="email"
              id="email"
              placeholder="Email"
              required
            />
            <textarea
              name="message"
              placeholder="Message"
              id="message"
              rows="6"
              required
            />
            <button type="submit">Send Message</button>
          </form>
        </>
      </Container>
    </div>
  );
}

export default ContactForm;
